import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const FigmaNodeStructureStateV2 = z.enum(["InProgress", "Success", "Failed"]);

export const FigmaNodeStructureV2 = z.object({
  id: z.string(),
  designSystemId: z.string(),
  sourceId: z.string(),
  storagePath: z.string().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  importState: FigmaNodeStructureStateV2,
  error: z.string().optional(),
  chunkSize: z.number().optional(),

  // TODO Artem: remove after migration
  isFromLegacyStorage: z.boolean(),
});

export type FigmaNodeStructureStateV2 = z.infer<typeof FigmaNodeStructureStateV2>;
export type FigmaNodeStructureV2 = z.infer<typeof FigmaNodeStructureV2>;

export type CreateFigmaNodeStructureV2 = OmitStrict<DbCreateInputOmit<FigmaNodeStructureV2>, "isFromLegacyStorage">;
export type UpdateFigmaNodeStructureV2 = OmitStrict<
  DbUpdate<FigmaNodeStructureV2>,
  "designSystemId" | "sourceId" | "isFromLegacyStorage"
>;
